import { getCookie } from "cookies-next";

export interface Session {
    accessToken: string | null;
    visitDetails: VisitDetails;
}

export interface VisitDetails {
    country?: string;
    countryCode?: string;
    region?: string;
    city?: string;
    ip?: string;
    visitorId?: string;
    userId?: string;
    visitId?: string;
    trafficSourceNetwork?: string | null;
    isMobile?: boolean;
}

export const getUserSessionFromCookies = (): Session | null => {
    const accessToken = getCookie("_tf_token")?.toString() ?? null;
    const visitorId = getCookie("_tf_visitorId")?.toString();
    const visitId = getCookie("_tf_visitId")?.toString();

    if (!accessToken && !visitorId && !visitId) {
        return null;
    }

    return {
        accessToken,
        visitDetails: {
            visitorId,
            visitId,
            country: getCookie("_tf_country")?.toString(),
            region: getCookie("_tf_region")?.toString(),
            isMobile: getCookie("_tf_isMobile") === "true",
        },
    };
};
